import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Spinner
} from '../../../config/react'
import DataTable from 'react-data-table-component'

const Roles = () => {
  const [RolesList, setRolesList] = useState([])
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [totalRows, settotalRows] = useState()
  const [SearchTerm, setSearchTerm] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const columns = [
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
      sortField: 'Name'
    },
    {
      name: 'Created Date',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>,
      sortable: true,
      sortField: 'created_at'
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          {row.name !== 'master' && (
            <div className="action-btn">
              <Link
                to={'/role/edit/' + row.id}
                className="text-dark"
                title="Edit"
              >
                <i
                  className="fa fa-pencil-square-o"
                  aria-hidden="true"
                ></i>{' '}
              </Link>
              <Link
                onClick={(e) => DeleteRole(e, row.id)}
                to=""
                className="text-dark"
                title="Delete"
              >
                <i
                  className="fa fa-trash-o"
                  aria-hidden="true"
                ></i>{' '}
              </Link>
            </div>
          )}
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    // search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.Roles
    GetRolesList()
  }, [CustomFilters, SearchTerm])

  const GetRolesList = () => {
    const param = {
      _page: CustomFilters.page,
      _search: SearchTerm,
      _page_size: CustomFilters.page_size,
      _sort_column: CustomFilters.sort_column,
      _sort_direction: CustomFilters.sort_direction
    }
    setLoading(true)
    HttpService.postApi(API.GetRoles, param).then((response) => {
      setLoading(false)
      if (response.data.status === true) {
        const data = response.data.result[1]
        settotalRows(response.data.result[0][0].total)
        setRolesList(data)
        setForceUpdate(!isForceUpdate)
      }
    })
  }
  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }
  const handleSort = (e, direction) => {
    // console.log('LN (91) Sort FIeld ' + e.sortField)
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
    // console.log(CustomFilters)
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Name."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) =>
          setTimeout(() => {
            setSearchTerm(e.target.value)
          }, 1000)
        }
      />
    )
  })

  const DeleteRole = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          _id: id
        }
        setLoading(true)
        HttpService.postApi(API.DeleteRole, param).then((response) => {
          setLoading(false)
          toast.success(Messages.RecordDeleted)
          GetRolesList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }

  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.Roles} </h3>
        <div className="btn-group">
          <Link
            to="/role/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add Role{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={RolesList}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  persistTableHead={true}
                  paginationDefaultPage={currentPage}
                  onSort={handleSort}
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  subHeaderComponent={subHeaderComponentMemo}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Roles
